import LegadoPostDonation from 'src/containers/legado/LegadoPostDonation';
import styled from '@emotion/styled';
import { sillaValue } from './LegadoSelectChairs';
import { clickableStyles, formatCurrency, s } from 'src/components/helpers';
import LegadoAllGuestDonations from './LegadoAllGuestDonations';
import { useState, useEffect } from 'react';
import { screenSizes } from 'src/assets/styles/Literals';
import PaymentInfoModal from 'src/components/common/PaymentInfoModal';
import { Modal, Button } from 'semantic-ui-react';

const PersonalProgressComp = styled.div`
  position: relative;
  background-color: white;

  .go-back-btn {
    position: absolute;
    top: 10px;
    left: 100px;
    margin-left: 0;
    margin-bottom: 1rem;
    background: transparent;
    color: #1e3a8a;
    border: 1px solid #1e3a8a;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
    padding: 4px 14px;
    cursor: pointer;
    z-index: 200;
    transition: background 0.2s, color 0.2s;

    @media (max-width: 1050px) {
      top: 30px;
      left: 55px;
    }

    @media (max-width: ${screenSizes.tablet}) {
      left: 25px;
    }
  }

  .go-back-btn:active {
    background: #e6eaff;
    color: #2746b3;
  }

  .donation-summary {
    margin: 30px 0 10px 0;
    padding: 0 0 20px 0px;
    text-align: center;
    @media (max-width: ${screenSizes.tablet}) {
      margin: 50px 0 0 0;
      padding: 0 10px 20px 10px;
    }
  }

  .donate-btn {
    background: #1e3a8a;
    color: white;
    font-size: 20px;
    font-weight: 600;
    padding: 18px 60px;
    border: none;
    border-radius: 32px;
    box-shadow: 0 2px 16px rgba(30, 58, 138, 0.12);
    cursor: pointer;
    z-index: 100;
    &.secondary {
      background: transparent;
      color: #1e3a8a;
      border: 1px solid #1e3a8a;
    }
  }

  .donate-btn-container {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 10px 0 30px 0;
    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
    }
  }

  p.payment-info-modal {
    padding: 50px 250px;
    margin: 0 0 10px 0;
    text-align: center;
    font-style: italic;
    @media (max-width: ${screenSizes.tablet}) {
      padding: 50px 40px;
    }
  }

  .donation-invite-modal {
    .modal-content {
      text-align: center;
      padding: 20px 0;
      .subtitle {
        font-size: 1.5rem;
        margin-bottom: 20px;
      }
      .invite-message {
        font-size: 1.1rem;
        line-height: 1.6;
        color: #4a5568;
        margin-bottom: 20px;
      }
    }
  }
`;

const LegadoPersonalProgress = (props) => {
  const { inputs, backTo, setCategory, refreshDonations, setInputs } = props;
  const [openGuestDonations, setOpenGuestDonations] = useState(false);
  const [paymentInfoModalOpen, setPaymentInfoModalOpen] = useState(false);
  const [donationInviteModalOpen, setDonationInviteModalOpen] = useState(false);

  // Show donation invitation modal when user has no donations
  useEffect(() => {
    if (inputs.userAllDonationsTotal === 0) {
      setDonationInviteModalOpen(true);
    }
  }, [inputs.userAllDonationsTotal]);

  const checkUserDonatedMoreThanCommited =
    inputs.userAllDonationsTotal > (parseFloat(inputs.chairsToCommit) || 1) * sillaValue;

  const milestones = [
    {
      number: 0,
      description: '$0',
    },
    {
      number: 0,
      description: formatCurrency(
        checkUserDonatedMoreThanCommited
          ? inputs.userAllDonationsTotal
          : (parseFloat(inputs.chairsToCommit) || 1) * sillaValue
      ),
    },
  ];

  const chairsDonated = inputs.userAllDonationsTotal / sillaValue;

  const decimals = chairsDonated.toString().split('.')[1];

  const progress =
    inputs.chairsToCommit > 0 ? (chairsDonated / inputs.chairsToCommit) * 100 : chairsDonated * 100;

  const handleBack = () => {
    setCategory(backTo);
    setInputs({
      chairsToCommit: 0,
      chairs: 1,
      valueToCommit: 0,
      identification: inputs.identification,
      phone: inputs.phone,
    });
  };

  return (
    <PersonalProgressComp>
      <button className="go-back-btn" onClick={handleBack}>
        Volver
      </button>
      <LegadoPostDonation
        progress={progress}
        title={`Así vas ${
          (decimals && parseFloat(chairsDonated) > 1) || inputs.chairsToCommit > 1
            ? `en la donación de tus sillas`
            : ''
        }`}
        milestones={milestones}
      />
      <div className="donation-summary">
        {!!inputs.electronicPaymentsTotal && (
          <p>
            Haz donado un total de {formatCurrency(inputs.electronicPaymentsTotal)} en pesos
            colombianos electrónicamente.
          </p>
        )}
        {!!inputs.manualPaymentsTotal && (
          <p>
            Haz donado un total de {formatCurrency(inputs.manualPaymentsTotal)} en pesos colombianos
            de forma manual.
          </p>
        )}
        {parseFloat(chairsDonated) > 0 && (
          <p>
            Tus donaciones equivalen a {parseFloat(chairsDonated).toFixed(2)} silla
            {s(chairsDonated)} y a {formatCurrency(inputs.userAllDonationsTotal)} pesos colombianos.
          </p>
        )}
        {inputs.chairsToCommit > 0 && (
          <p>
            Te comprometiste con {inputs.chairsToCommit} silla{s(inputs.chairsToCommit)} en total,
            que equivalen a {formatCurrency(inputs.chairsToCommit * sillaValue)} en pesos
            colombianos. <br />
            {parseFloat(inputs.chairsToCommit * sillaValue - inputs.userAllDonationsTotal) > 0 ? (
              <span style={{ fontWeight: 600 }}>
                Te queda pendiente donar{' '}
                {formatCurrency(inputs.chairsToCommit * sillaValue - inputs.userAllDonationsTotal)}{' '}
                en pesos colombianos para llegar a tu meta.{' '}
              </span>
            ) : (
              <>
                <span style={{ fontWeight: 600 }}>Ya superaste tu meta. Quieres aumentarla? </span>
                <span
                  onClick={() => setCategory('donateSillaInParts')}
                  style={{ ...clickableStyles, color: '#1e3a8a' }}
                >
                  Cambiar mi meta
                </span>
              </>
            )}
          </p>
        )}
        <p style={{ fontWeight: 600 }}>
          Recuerda que cada silla representa una vida transformada por un encuentro con Jesús.
        </p>
      </div>
      <div className="donate-btn-container">
        <button className="donate-btn" onClick={() => setCategory('donateSillaInParts')}>
          {inputs.userAllDonationsTotal > 0 ? 'Dar mi siguiente contribución' : 'Ir a donar'}
        </button>
      </div>
      {openGuestDonations && (
        <LegadoAllGuestDonations
          setOpen={setOpenGuestDonations}
          inputs={inputs}
          refreshDonations={refreshDonations}
        />
      )}
      <div className="donate-btn-container">
        <button className="donate-btn secondary" onClick={() => setOpenGuestDonations(true)}>
          Ver mis donaciones
        </button>
        <button className="donate-btn" onClick={() => setCategory('totalChurch')}>
          Ver el avance total
        </button>
      </div>
      <div className="donate-btn-container">
        <button className="donate-btn secondary" onClick={() => setCategory('promiseForm')}>
          Cambiar mi meta
        </button>
      </div>
      <p className="payment-info-modal">
        <strong>Atención:</strong> Estos datos son informativos de tus avances totales, incluyendo
        los manuales. Recuerda que las donaciones que realices a través de otros canales deberán ser
        reportadas por los diferentes medios que tiene la iglesia. Solo podrás solicitar tu
        certificado anual para la declaración de renta por las donaciones efectivamente ingresadas y
        reportadas en debida forma.{' '}
        <PaymentInfoModal
          open={paymentInfoModalOpen}
          setPaymentInfoModalOpen={setPaymentInfoModalOpen}
        />
      </p>

      {donationInviteModalOpen && (
        <Modal
          open
          onClose={() => setDonationInviteModalOpen(false)}
          size="small"
          className="donation-invite-modal"
        >
          <Modal.Header>¡Felicitaciones por tu compromiso!</Modal.Header>
          <Modal.Content>
            <div className="modal-content">
              <p className="subtitle">
                Construir legado es un sueño de todos, ahora tú también eres parte.
              </p>
              <div className="invite-message">
                <span style={clickableStyles} onClick={() => setCategory('donateSillaInParts')}>
                  Si deseas donar ahora mismo haz clic aquí
                </span>
              </div>
              <div className="invite-message">
                Recuerda que si realizas una donación en efectivo, transferencia o datáfono, debes
                llenar el sobre de ofrenda, marcar "pro - templo"{' '}
                <span
                  style={clickableStyles}
                  onClick={() => {
                    setDonationInviteModalOpen(false);
                    setOpenGuestDonations(true);
                  }}
                >
                  y actualizar tu termómetro de forma manual haciendo clic aquí
                </span>
              </div>
              <div className="invite-message">¡Gracias familia!</div>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => setDonationInviteModalOpen(false)}>Tal vez después</Button>
            <Button
              primary
              onClick={() => {
                setDonationInviteModalOpen(false);
                setCategory('donateSillaInParts');
              }}
            >
              ¡Quiero donar ahora!
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </PersonalProgressComp>
  );
};

export default LegadoPersonalProgress;
